/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import ContentSlider from "@qlik/qlik/src/components/ContentSlider";
import Media from "@qlik/qlik/src/components/Media";
import RichText from "@qlik/qlik/src/components/RichText";
import { getCardEyebrowText, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

// Slider settings
const settings = {
    slidesToShow: 8,
    infinite: true,
    speed: 1500,
    centerMode: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    pauseOnHover: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
                dots: false,
                arrows: true,
            },
        },
        {
            breakpoint: 978,
            settings: {
                slidesToShow: 5,
                centerPadding: "20px",
                dots: false,
                arrows: true,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                centerPadding: "120px",
                dots: false,
                arrows: false,
            },
        },
        {
            breakpoint: 475,
            settings: {
                slidesToShow: 3,
                arrows: false,
                centerMode: true,
            },
        },
    ],
};

const HeroBannerLogoSlider = ({ data }) => {
    const { title, body, cta = [], cardItems = [], customId } = data ?? {};
    // Get eyebrow text from 1st cardItem (since a CardDeckcontainer FE component can have more than one card item)
    const cardEyebrowText = cardItems.length > 0 && getCardEyebrowText(cardItems[0]);
    const grayLine = '<span class="text-stone text-4xl lg:text-7xl font-light">|</span>';
    return (
        <section
            className={`overflow-hidden pt-10 lg:pb-10 lg:pt-20 bg-no-repeat bg-heroBannerSliderBgImage ${styles.section}`}
            id={customId}
        >
            <div className="xxl:max-w-360 mx-auto">
                {cardEyebrowText && (
                    <p className="tag-2 uppercase text-sm mt-5 mb-3 text-center mx-auto">{cardEyebrowText}</p>
                )}
                {title && (
                    <h1
                        className="text-blue text-center mx-auto mb-3.75 lg:mb-7.5 max-w-[310px] lg:max-w-[830px]"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title?.replace("|", grayLine)) }}
                    />
                )}
                {body && (
                    <RichText data={data} className={`mx-auto max-w-[830px] mb-7.5 lg:mb-12.5 ${styles.description}`} />
                )}
                <div className="flex flex-col items-center lg:flex-row gap-5 lg:gap-5 mb-6.75 lg:mb-22.25 justify-center">
                    {cta?.map((button) => (
                        <div key={button?.id}>
                            <Cta key={button?.id} data={button} />
                        </div>
                    ))}
                </div>
                <ContentSlider className={`${styles.slickSlideWrapper}`} settings={settings}>
                    {cardItems?.map((card) => (
                        <div key={card?.id}>
                            <div className="flex gap-5 rounded-sm w-15 lg:w-30 ">
                                <Media
                                    media={card?.media?.[0]}
                                    className="object-cover object-left rounded w-15 h-15 lg:w-30 lg:h-[120px] shadow-lg"
                                />
                            </div>
                        </div>
                    ))}
                </ContentSlider>
            </div>
        </section>
    );
};

export default HeroBannerLogoSlider;
